/**
 * Historical SOFR Overnight Rates
 *
 * Source: Federal Reserve Bank of New York / FRED (SOFR series).
 * Rates are stored as annual percentages (e.g., 3.60 = 3.60% annual).
 *
 * This is the rate series used when computing option greeks under the
 * SOFR + q=0 convention. Distinct from treasury-rates.ts, which holds
 * 3-month T-bill yields used for portfolio Sharpe/Sortino calculations.
 *
 * SOFR is not published on US bank holidays — those rows are absent and the
 * lookup falls back to the most recent prior trading day's rate.
 *
 * To update: fetch the SOFR series from FRED and append new rows below.
 */

export const SOFR_RATES: Record<string, number> = {
  "2022-01-03": 0.05,
  "2022-01-04": 0.05,
  "2022-01-05": 0.05,
  "2022-01-06": 0.05,
  "2022-01-07": 0.05,
  "2022-01-10": 0.05,
  "2022-01-11": 0.05,
  "2022-01-12": 0.05,
  "2022-01-13": 0.05,
  "2022-01-14": 0.05,
  "2022-01-18": 0.05,
  "2022-01-19": 0.05,
  "2022-01-20": 0.04,
  "2022-01-21": 0.05,
  "2022-01-24": 0.04,
  "2022-01-25": 0.05,
  "2022-01-26": 0.04,
  "2022-01-27": 0.04,
  "2022-01-28": 0.05,
  "2022-01-31": 0.05,
  "2022-02-01": 0.05,
  "2022-02-02": 0.05,
  "2022-02-03": 0.05,
  "2022-02-04": 0.05,
  "2022-02-07": 0.05,
  "2022-02-08": 0.05,
  "2022-02-09": 0.04,
  "2022-02-10": 0.05,
  "2022-02-11": 0.05,
  "2022-02-14": 0.05,
  "2022-02-15": 0.05,
  "2022-02-16": 0.05,
  "2022-02-17": 0.05,
  "2022-02-18": 0.05,
  "2022-02-22": 0.05,
  "2022-02-23": 0.05,
  "2022-02-24": 0.05,
  "2022-02-25": 0.05,
  "2022-02-28": 0.05,
  "2022-03-01": 0.05,
  "2022-03-02": 0.05,
  "2022-03-03": 0.05,
  "2022-03-04": 0.05,
  "2022-03-07": 0.05,
  "2022-03-08": 0.05,
  "2022-03-09": 0.05,
  "2022-03-10": 0.05,
  "2022-03-11": 0.05,
  "2022-03-14": 0.05,
  "2022-03-15": 0.05,
  "2022-03-16": 0.05,
  "2022-03-17": 0.3,
  "2022-03-18": 0.3,
  "2022-03-21": 0.29,
  "2022-03-22": 0.28,
  "2022-03-23": 0.27,
  "2022-03-24": 0.27,
  "2022-03-25": 0.28,
  "2022-03-28": 0.28,
  "2022-03-29": 0.28,
  "2022-03-30": 0.27,
  "2022-03-31": 0.29,
  "2022-04-01": 0.3,
  "2022-04-04": 0.3,
  "2022-04-05": 0.3,
  "2022-04-06": 0.3,
  "2022-04-07": 0.3,
  "2022-04-08": 0.3,
  "2022-04-11": 0.3,
  "2022-04-12": 0.29,
  "2022-04-13": 0.29,
  "2022-04-14": 0.29,
  "2022-04-18": 0.29,
  "2022-04-19": 0.28,
  "2022-04-20": 0.27,
  "2022-04-21": 0.26,
  "2022-04-22": 0.27,
  "2022-04-25": 0.27,
  "2022-04-26": 0.27,
  "2022-04-27": 0.28,
  "2022-04-28": 0.28,
  "2022-04-29": 0.28,
  "2022-05-02": 0.3,
  "2022-05-03": 0.3,
  "2022-05-04": 0.3,
  "2022-05-05": 0.79,
  "2022-05-06": 0.78,
  "2022-05-09": 0.78,
  "2022-05-10": 0.78,
  "2022-05-11": 0.78,
  "2022-05-12": 0.79,
  "2022-05-13": 0.79,
  "2022-05-16": 0.8,
  "2022-05-17": 0.8,
  "2022-05-18": 0.79,
  "2022-05-19": 0.79,
  "2022-05-20": 0.78,
  "2022-05-23": 0.78,
  "2022-05-24": 0.78,
  "2022-05-25": 0.78,
  "2022-05-26": 0.78,
  "2022-05-27": 0.78,
  "2022-05-31": 0.79,
  "2022-06-01": 0.8,
  "2022-06-02": 0.79,
  "2022-06-03": 0.78,
  "2022-06-06": 0.78,
  "2022-06-07": 0.77,
  "2022-06-08": 0.76,
  "2022-06-09": 0.75,
  "2022-06-10": 0.75,
  "2022-06-13": 0.73,
  "2022-06-14": 0.69,
  "2022-06-15": 0.7,
  "2022-06-16": 1.45,
  "2022-06-17": 1.45,
  "2022-06-21": 1.45,
  "2022-06-22": 1.45,
  "2022-06-23": 1.44,
  "2022-06-24": 1.46,
  "2022-06-27": 1.5,
  "2022-06-28": 1.52,
  "2022-06-29": 1.51,
  "2022-06-30": 1.5,
  "2022-07-01": 1.52,
  "2022-07-05": 1.54,
  "2022-07-06": 1.54,
  "2022-07-07": 1.54,
  "2022-07-08": 1.53,
  "2022-07-11": 1.53,
  "2022-07-12": 1.54,
  "2022-07-13": 1.53,
  "2022-07-14": 1.53,
  "2022-07-15": 1.54,
  "2022-07-18": 1.54,
  "2022-07-19": 1.54,
  "2022-07-20": 1.53,
  "2022-07-21": 1.53,
  "2022-07-22": 1.52,
  "2022-07-25": 1.53,
  "2022-07-26": 1.53,
  "2022-07-27": 1.53,
  "2022-07-28": 2.28,
  "2022-07-29": 2.27,
  "2022-08-01": 2.28,
  "2022-08-02": 2.3,
  "2022-08-03": 2.29,
  "2022-08-04": 2.29,
  "2022-08-05": 2.28,
  "2022-08-08": 2.28,
  "2022-08-09": 2.29,
  "2022-08-10": 2.28,
  "2022-08-11": 2.28,
  "2022-08-12": 2.28,
  "2022-08-15": 2.29,
  "2022-08-16": 2.29,
  "2022-08-17": 2.29,
  "2022-08-18": 2.28,
  "2022-08-19": 2.28,
  "2022-08-22": 2.28,
  "2022-08-23": 2.27,
  "2022-08-24": 2.27,
  "2022-08-25": 2.28,
  "2022-08-26": 2.28,
  "2022-08-29": 2.28,
  "2022-08-30": 2.29,
  "2022-08-31": 2.29,
  "2022-09-01": 2.29,
  "2022-09-02": 2.29,
  "2022-09-06": 2.29,
  "2022-09-07": 2.28,
  "2022-09-08": 2.28,
  "2022-09-09": 2.28,
  "2022-09-12": 2.28,
  "2022-09-13": 2.28,
  "2022-09-14": 2.27,
  "2022-09-15": 2.28,
  "2022-09-16": 2.27,
  "2022-09-19": 2.27,
  "2022-09-20": 2.26,
  "2022-09-21": 2.25,
  "2022-09-22": 2.99,
  "2022-09-23": 2.99,
  "2022-09-26": 2.99,
  "2022-09-27": 2.98,
  "2022-09-28": 2.98,
  "2022-09-29": 2.96,
  "2022-09-30": 2.98,
  "2022-10-03": 3.0,
  "2022-10-04": 3.04,
  "2022-10-05": 3.04,
  "2022-10-06": 3.05,
  "2022-10-07": 3.05,
  "2022-10-11": 3.05,
  "2022-10-12": 3.04,
  "2022-10-13": 3.04,
  "2022-10-14": 3.04,
  "2022-10-17": 3.05,
  "2022-10-18": 3.04,
  "2022-10-19": 3.04,
  "2022-10-20": 3.03,
  "2022-10-21": 3.02,
  "2022-10-24": 3.01,
  "2022-10-25": 3.02,
  "2022-10-26": 3.03,
  "2022-10-27": 3.04,
  "2022-10-28": 3.05,
  "2022-10-31": 3.05,
  "2022-11-01": 3.05,
  "2022-11-02": 3.05,
  "2022-11-03": 3.8,
  "2022-11-04": 3.8,
  "2022-11-07": 3.78,
  "2022-11-08": 3.78,
  "2022-11-09": 3.78,
  "2022-11-10": 3.78,
  "2022-11-14": 3.79,
  "2022-11-15": 3.8,
  "2022-11-16": 3.81,
  "2022-11-17": 3.8,
  "2022-11-18": 3.8,
  "2022-11-21": 3.8,
  "2022-11-22": 3.8,
  "2022-11-23": 3.79,
  "2022-11-25": 3.8,
  "2022-11-28": 3.8,
  "2022-11-29": 3.81,
  "2022-11-30": 3.82,
  "2022-12-01": 3.82,
  "2022-12-02": 3.81,
  "2022-12-05": 3.81,
  "2022-12-06": 3.8,
  "2022-12-07": 3.8,
  "2022-12-08": 3.8,
  "2022-12-09": 3.8,
  "2022-12-12": 3.8,
  "2022-12-13": 3.8,
  "2022-12-14": 3.8,
  "2022-12-15": 4.32,
  "2022-12-16": 4.32,
  "2022-12-19": 4.3,
  "2022-12-20": 4.3,
  "2022-12-21": 4.3,
  "2022-12-22": 4.3,
  "2022-12-23": 4.3,
  "2022-12-27": 4.3,
  "2022-12-28": 4.3,
  "2022-12-29": 4.3,
  "2022-12-30": 4.3,
  "2023-01-03": 4.31,
  "2023-01-04": 4.3,
  "2023-01-05": 4.31,
  "2023-01-06": 4.31,
  "2023-01-09": 4.31,
  "2023-01-10": 4.31,
  "2023-01-11": 4.3,
  "2023-01-12": 4.3,
  "2023-01-13": 4.3,
  "2023-01-17": 4.31,
  "2023-01-18": 4.3,
  "2023-01-19": 4.31,
  "2023-01-20": 4.3,
  "2023-01-23": 4.3,
  "2023-01-24": 4.3,
  "2023-01-25": 4.31,
  "2023-01-26": 4.3,
  "2023-01-27": 4.3,
  "2023-01-30": 4.3,
  "2023-01-31": 4.31,
  "2023-02-01": 4.31,
  "2023-02-02": 4.56,
  "2023-02-03": 4.55,
  "2023-02-06": 4.55,
  "2023-02-07": 4.55,
  "2023-02-08": 4.55,
  "2023-02-09": 4.55,
  "2023-02-10": 4.55,
  "2023-02-13": 4.55,
  "2023-02-14": 4.55,
  "2023-02-15": 4.55,
  "2023-02-16": 4.55,
  "2023-02-17": 4.55,
  "2023-02-21": 4.55,
  "2023-02-22": 4.55,
  "2023-02-23": 4.55,
  "2023-02-24": 4.55,
  "2023-02-27": 4.55,
  "2023-02-28": 4.55,
  "2023-03-01": 4.55,
  "2023-03-02": 4.55,
  "2023-03-03": 4.55,
  "2023-03-06": 4.55,
  "2023-03-07": 4.55,
  "2023-03-08": 4.55,
  "2023-03-09": 4.55,
  "2023-03-10": 4.55,
  "2023-03-13": 4.55,
  "2023-03-14": 4.55,
  "2023-03-15": 4.58,
  "2023-03-16": 4.57,
  "2023-03-17": 4.55,
  "2023-03-20": 4.55,
  "2023-03-21": 4.55,
  "2023-03-22": 4.55,
  "2023-03-23": 4.8,
  "2023-03-24": 4.8,
  "2023-03-27": 4.81,
  "2023-03-28": 4.84,
  "2023-03-29": 4.83,
  "2023-03-30": 4.82,
  "2023-03-31": 4.87,
  "2023-04-03": 4.84,
  "2023-04-04": 4.83,
  "2023-04-05": 4.81,
  "2023-04-06": 4.81,
  "2023-04-10": 4.81,
  "2023-04-11": 4.8,
  "2023-04-12": 4.8,
  "2023-04-13": 4.8,
  "2023-04-14": 4.8,
  "2023-04-17": 4.8,
  "2023-04-18": 4.8,
  "2023-04-19": 4.8,
  "2023-04-20": 4.8,
  "2023-04-21": 4.8,
  "2023-04-24": 4.8,
  "2023-04-25": 4.8,
  "2023-04-26": 4.8,
  "2023-04-27": 4.81,
  "2023-04-28": 4.81,
  "2023-05-01": 4.81,
  "2023-05-02": 4.81,
  "2023-05-03": 4.81,
  "2023-05-04": 5.06,
  "2023-05-05": 5.06,
  "2023-05-08": 5.06,
  "2023-05-09": 5.06,
  "2023-05-10": 5.06,
  "2023-05-11": 5.05,
  "2023-05-12": 5.05,
  "2023-05-15": 5.06,
  "2023-05-16": 5.05,
  "2023-05-17": 5.05,
  "2023-05-18": 5.05,
  "2023-05-19": 5.05,
  "2023-05-22": 5.05,
  "2023-05-23": 5.05,
  "2023-05-24": 5.05,
  "2023-05-25": 5.06,
  "2023-05-26": 5.06,
  "2023-05-30": 5.06,
  "2023-05-31": 5.08,
  "2023-06-01": 5.08,
  "2023-06-02": 5.07,
  "2023-06-05": 5.06,
  "2023-06-06": 5.05,
  "2023-06-07": 5.05,
  "2023-06-08": 5.05,
  "2023-06-09": 5.05,
  "2023-06-12": 5.05,
  "2023-06-13": 5.05,
  "2023-06-14": 5.05,
  "2023-06-15": 5.06,
  "2023-06-16": 5.05,
  "2023-06-20": 5.05,
  "2023-06-21": 5.05,
  "2023-06-22": 5.05,
  "2023-06-23": 5.05,
  "2023-06-26": 5.05,
  "2023-06-27": 5.05,
  "2023-06-28": 5.06,
  "2023-06-29": 5.06,
  "2023-06-30": 5.09,
  "2023-07-03": 5.06,
  "2023-07-05": 5.06,
  "2023-07-06": 5.06,
  "2023-07-07": 5.06,
  "2023-07-10": 5.06,
  "2023-07-11": 5.06,
  "2023-07-12": 5.05,
  "2023-07-13": 5.06,
  "2023-07-14": 5.05,
  "2023-07-17": 5.06,
  "2023-07-18": 5.06,
  "2023-07-19": 5.05,
  "2023-07-20": 5.06,
  "2023-07-21": 5.05,
  "2023-07-24": 5.05,
  "2023-07-25": 5.06,
  "2023-07-26": 5.06,
  "2023-07-27": 5.31,
  "2023-07-28": 5.3,
  "2023-07-31": 5.31,
  "2023-08-01": 5.31,
  "2023-08-02": 5.3,
  "2023-08-03": 5.3,
  "2023-08-04": 5.3,
  "2023-08-07": 5.3,
  "2023-08-08": 5.3,
  "2023-08-09": 5.3,
  "2023-08-10": 5.3,
  "2023-08-11": 5.3,
  "2023-08-14": 5.3,
  "2023-08-15": 5.3,
  "2023-08-16": 5.3,
  "2023-08-17": 5.3,
  "2023-08-18": 5.3,
  "2023-08-21": 5.3,
  "2023-08-22": 5.3,
  "2023-08-23": 5.3,
  "2023-08-24": 5.3,
  "2023-08-25": 5.3,
  "2023-08-28": 5.3,
  "2023-08-29": 5.3,
  "2023-08-30": 5.3,
  "2023-08-31": 5.31,
  "2023-09-01": 5.31,
  "2023-09-05": 5.31,
  "2023-09-06": 5.3,
  "2023-09-07": 5.31,
  "2023-09-08": 5.3,
  "2023-09-11": 5.3,
  "2023-09-12": 5.3,
  "2023-09-13": 5.3,
  "2023-09-14": 5.3,
  "2023-09-15": 5.31,
  "2023-09-18": 5.31,
  "2023-09-19": 5.31,
  "2023-09-20": 5.3,
  "2023-09-21": 5.3,
  "2023-09-22": 5.3,
  "2023-09-25": 5.31,
  "2023-09-26": 5.31,
  "2023-09-27": 5.32,
  "2023-09-28": 5.31,
  "2023-09-29": 5.31,
  "2023-10-02": 5.32,
  "2023-10-03": 5.33,
  "2023-10-04": 5.32,
  "2023-10-05": 5.32,
  "2023-10-06": 5.31,
  "2023-10-10": 5.31,
  "2023-10-11": 5.31,
  "2023-10-12": 5.31,
  "2023-10-13": 5.31,
  "2023-10-16": 5.31,
  "2023-10-17": 5.31,
  "2023-10-18": 5.3,
  "2023-10-19": 5.3,
  "2023-10-20": 5.3,
  "2023-10-23": 5.3,
  "2023-10-24": 5.3,
  "2023-10-25": 5.3,
  "2023-10-26": 5.31,
  "2023-10-27": 5.31,
  "2023-10-30": 5.31,
  "2023-10-31": 5.35,
  "2023-11-01": 5.32,
  "2023-11-02": 5.33,
  "2023-11-03": 5.32,
  "2023-11-06": 5.32,
  "2023-11-07": 5.32,
  "2023-11-08": 5.32,
  "2023-11-09": 5.32,
  "2023-11-10": 5.32,
  "2023-11-13": 5.32,
  "2023-11-14": 5.32,
  "2023-11-15": 5.32,
  "2023-11-16": 5.32,
  "2023-11-17": 5.32,
  "2023-11-20": 5.31,
  "2023-11-21": 5.31,
  "2023-11-22": 5.31,
  "2023-11-24": 5.32,
  "2023-11-27": 5.32,
  "2023-11-28": 5.32,
  "2023-11-29": 5.31,
  "2023-11-30": 5.33,
  "2023-12-01": 5.39,
  "2023-12-04": 5.37,
  "2023-12-05": 5.33,
  "2023-12-06": 5.32,
  "2023-12-07": 5.32,
  "2023-12-08": 5.32,
  "2023-12-11": 5.32,
  "2023-12-12": 5.31,
  "2023-12-13": 5.31,
  "2023-12-14": 5.31,
  "2023-12-15": 5.32,
  "2023-12-18": 5.32,
  "2023-12-19": 5.31,
  "2023-12-20": 5.31,
  "2023-12-21": 5.31,
  "2023-12-22": 5.32,
  "2023-12-26": 5.35,
  "2023-12-27": 5.39,
  "2023-12-28": 5.4,
  "2023-12-29": 5.38,
  "2024-01-02": 5.4,
  "2024-01-03": 5.39,
  "2024-01-04": 5.32,
  "2024-01-05": 5.31,
  "2024-01-08": 5.31,
  "2024-01-09": 5.31,
  "2024-01-10": 5.31,
  "2024-01-11": 5.31,
  "2024-01-12": 5.31,
  "2024-01-16": 5.32,
  "2024-01-17": 5.32,
  "2024-01-18": 5.31,
  "2024-01-19": 5.31,
  "2024-01-22": 5.31,
  "2024-01-23": 5.31,
  "2024-01-24": 5.31,
  "2024-01-25": 5.32,
  "2024-01-26": 5.32,
  "2024-01-29": 5.31,
  "2024-01-30": 5.31,
  "2024-01-31": 5.32,
  "2024-02-01": 5.32,
  "2024-02-02": 5.32,
  "2024-02-05": 5.31,
  "2024-02-06": 5.31,
  "2024-02-07": 5.31,
  "2024-02-08": 5.31,
  "2024-02-09": 5.31,
  "2024-02-12": 5.31,
  "2024-02-13": 5.31,
  "2024-02-14": 5.3,
  "2024-02-15": 5.31,
  "2024-02-16": 5.3,
  "2024-02-20": 5.3,
  "2024-02-21": 5.3,
  "2024-02-22": 5.3,
  "2024-02-23": 5.31,
  "2024-02-26": 5.31,
  "2024-02-27": 5.31,
  "2024-02-28": 5.31,
  "2024-02-29": 5.32,
  "2024-03-01": 5.31,
  "2024-03-04": 5.31,
  "2024-03-05": 5.31,
  "2024-03-06": 5.31,
  "2024-03-07": 5.31,
  "2024-03-08": 5.31,
  "2024-03-11": 5.31,
  "2024-03-12": 5.31,
  "2024-03-13": 5.31,
  "2024-03-14": 5.31,
  "2024-03-15": 5.31,
  "2024-03-18": 5.31,
  "2024-03-19": 5.31,
  "2024-03-20": 5.31,
  "2024-03-21": 5.31,
  "2024-03-22": 5.31,
  "2024-03-25": 5.31,
  "2024-03-26": 5.32,
  "2024-03-27": 5.33,
  "2024-03-28": 5.34,
  "2024-04-01": 5.35,
  "2024-04-02": 5.34,
  "2024-04-03": 5.32,
  "2024-04-04": 5.32,
  "2024-04-05": 5.32,
  "2024-04-08": 5.31,
  "2024-04-09": 5.31,
  "2024-04-10": 5.31,
  "2024-04-11": 5.31,
  "2024-04-12": 5.31,
  "2024-04-15": 5.32,
  "2024-04-16": 5.31,
  "2024-04-17": 5.31,
  "2024-04-18": 5.3,
  "2024-04-19": 5.31,
  "2024-04-22": 5.31,
  "2024-04-23": 5.31,
  "2024-04-24": 5.31,
  "2024-04-25": 5.31,
  "2024-04-26": 5.32,
  "2024-04-29": 5.32,
  "2024-04-30": 5.34,
  "2024-05-01": 5.32,
  "2024-05-02": 5.31,
  "2024-05-03": 5.31,
  "2024-05-06": 5.31,
  "2024-05-07": 5.31,
  "2024-05-08": 5.31,
  "2024-05-09": 5.31,
  "2024-05-10": 5.31,
  "2024-05-13": 5.31,
  "2024-05-14": 5.31,
  "2024-05-15": 5.31,
  "2024-05-16": 5.31,
  "2024-05-17": 5.31,
  "2024-05-20": 5.31,
  "2024-05-21": 5.31,
  "2024-05-22": 5.31,
  "2024-05-23": 5.31,
  "2024-05-24": 5.32,
  "2024-05-28": 5.32,
  "2024-05-29": 5.33,
  "2024-05-30": 5.33,
  "2024-05-31": 5.34,
  "2024-06-03": 5.35,
  "2024-06-04": 5.33,
  "2024-06-05": 5.33,
  "2024-06-06": 5.33,
  "2024-06-07": 5.33,
  "2024-06-10": 5.32,
  "2024-06-11": 5.32,
  "2024-06-12": 5.31,
  "2024-06-13": 5.31,
  "2024-06-14": 5.31,
  "2024-06-17": 5.33,
  "2024-06-18": 5.33,
  "2024-06-20": 5.32,
  "2024-06-21": 5.31,
  "2024-06-24": 5.31,
  "2024-06-25": 5.33,
  "2024-06-26": 5.34,
  "2024-06-27": 5.34,
  "2024-06-28": 5.33,
  "2024-07-01": 5.4,
  "2024-07-02": 5.35,
  "2024-07-03": 5.33,
  "2024-07-05": 5.32,
  "2024-07-08": 5.32,
  "2024-07-09": 5.34,
  "2024-07-10": 5.34,
  "2024-07-11": 5.34,
  "2024-07-12": 5.34,
  "2024-07-15": 5.34,
  "2024-07-16": 5.35,
  "2024-07-17": 5.35,
  "2024-07-18": 5.34,
  "2024-07-19": 5.34,
  "2024-07-22": 5.33,
  "2024-07-23": 5.34,
  "2024-07-24": 5.34,
  "2024-07-25": 5.35,
  "2024-07-26": 5.35,
  "2024-07-29": 5.33,
  "2024-07-30": 5.33,
  "2024-07-31": 5.38,
  "2024-08-01": 5.35,
  "2024-08-02": 5.35,
  "2024-08-05": 5.32,
  "2024-08-06": 5.33,
  "2024-08-07": 5.33,
  "2024-08-08": 5.34,
  "2024-08-09": 5.34,
  "2024-08-12": 5.34,
  "2024-08-13": 5.34,
  "2024-08-14": 5.33,
  "2024-08-15": 5.35,
  "2024-08-16": 5.32,
  "2024-08-19": 5.32,
  "2024-08-20": 5.32,
  "2024-08-21": 5.31,
  "2024-08-22": 5.31,
  "2024-08-23": 5.33,
  "2024-08-26": 5.34,
  "2024-08-27": 5.35,
  "2024-08-28": 5.35,
  "2024-08-29": 5.33,
  "2024-08-30": 5.32,
  "2024-09-03": 5.34,
  "2024-09-04": 5.35,
  "2024-09-05": 5.35,
  "2024-09-06": 5.34,
  "2024-09-09": 5.34,
  "2024-09-10": 5.33,
  "2024-09-11": 5.32,
  "2024-09-12": 5.33,
  "2024-09-13": 5.33,
  "2024-09-16": 5.38,
  "2024-09-17": 5.38,
  "2024-09-18": 5.33,
  "2024-09-19": 4.82,
  "2024-09-20": 4.83,
  "2024-09-23": 4.83,
  "2024-09-24": 4.84,
  "2024-09-25": 4.84,
  "2024-09-26": 4.83,
  "2024-09-27": 4.84,
  "2024-09-30": 4.96,
  "2024-10-01": 5.05,
  "2024-10-02": 4.92,
  "2024-10-03": 4.85,
  "2024-10-04": 4.83,
  "2024-10-07": 4.83,
  "2024-10-08": 4.84,
  "2024-10-09": 4.83,
  "2024-10-10": 4.82,
  "2024-10-11": 4.81,
  "2024-10-15": 4.86,
  "2024-10-16": 4.86,
  "2024-10-17": 4.85,
  "2024-10-18": 4.84,
  "2024-10-21": 4.82,
  "2024-10-22": 4.83,
  "2024-10-23": 4.83,
  "2024-10-24": 4.83,
  "2024-10-25": 4.83,
  "2024-10-28": 4.82,
  "2024-10-29": 4.82,
  "2024-10-30": 4.81,
  "2024-10-31": 4.9,
  "2024-11-01": 4.86,
  "2024-11-04": 4.82,
  "2024-11-05": 4.82,
  "2024-11-06": 4.81,
  "2024-11-07": 4.82,
  "2024-11-08": 4.6,
  "2024-11-12": 4.6,
  "2024-11-13": 4.59,
  "2024-11-14": 4.58,
  "2024-11-15": 4.57,
  "2024-11-18": 4.57,
  "2024-11-19": 4.57,
  "2024-11-20": 4.56,
  "2024-11-21": 4.57,
  "2024-11-22": 4.57,
  "2024-11-25": 4.58,
  "2024-11-26": 4.58,
  "2024-11-27": 4.57,
  "2024-11-29": 4.59,
  "2024-12-02": 4.64,
  "2024-12-03": 4.64,
  "2024-12-04": 4.59,
  "2024-12-05": 4.59,
  "2024-12-06": 4.6,
  "2024-12-09": 4.63,
  "2024-12-10": 4.64,
  "2024-12-11": 4.62,
  "2024-12-12": 4.62,
  "2024-12-13": 4.6,
  "2024-12-16": 4.65,
  "2024-12-17": 4.62,
  "2024-12-18": 4.57,
  "2024-12-19": 4.3,
  "2024-12-20": 4.3,
  "2024-12-23": 4.31,
  "2024-12-24": 4.4,
  "2024-12-26": 4.53,
  "2024-12-27": 4.46,
  "2024-12-30": 4.37,
  "2024-12-31": 4.49,
  "2025-01-02": 4.4,
  "2025-01-03": 4.31,
  "2025-01-06": 4.27,
  "2025-01-07": 4.27,
  "2025-01-08": 4.29,
  "2025-01-09": 4.3,
  "2025-01-10": 4.3,
  "2025-01-13": 4.29,
  "2025-01-14": 4.28,
  "2025-01-15": 4.28,
  "2025-01-16": 4.29,
  "2025-01-17": 4.29,
  "2025-01-21": 4.29,
  "2025-01-22": 4.3,
  "2025-01-23": 4.35,
  "2025-01-24": 4.34,
  "2025-01-27": 4.34,
  "2025-01-28": 4.35,
  "2025-01-29": 4.35,
  "2025-01-30": 4.36,
  "2025-01-31": 4.38,
  "2025-02-03": 4.35,
  "2025-02-04": 4.33,
  "2025-02-05": 4.33,
  "2025-02-06": 4.36,
  "2025-02-07": 4.35,
  "2025-02-10": 4.35,
  "2025-02-11": 4.34,
  "2025-02-12": 4.32,
  "2025-02-13": 4.33,
  "2025-02-14": 4.33,
  "2025-02-18": 4.37,
  "2025-02-19": 4.35,
  "2025-02-20": 4.33,
  "2025-02-21": 4.34,
  "2025-02-24": 4.34,
  "2025-02-25": 4.33,
  "2025-02-26": 4.33,
  "2025-02-27": 4.36,
  "2025-02-28": 4.39,
  "2025-03-03": 4.33,
  "2025-03-04": 4.33,
  "2025-03-05": 4.34,
  "2025-03-06": 4.35,
  "2025-03-07": 4.34,
  "2025-03-10": 4.33,
  "2025-03-11": 4.32,
  "2025-03-12": 4.31,
  "2025-03-13": 4.3,
  "2025-03-14": 4.3,
  "2025-03-17": 4.32,
  "2025-03-18": 4.31,
  "2025-03-19": 4.29,
  "2025-03-20": 4.29,
  "2025-03-21": 4.3,
  "2025-03-24": 4.31,
  "2025-03-25": 4.33,
  "2025-03-26": 4.35,
  "2025-03-27": 4.36,
  "2025-03-28": 4.34,
  "2025-03-31": 4.41,
  "2025-04-01": 4.39,
  "2025-04-02": 4.37,
  "2025-04-03": 4.39,
  "2025-04-04": 4.35,
  "2025-04-07": 4.33,
  "2025-04-08": 4.4,
  "2025-04-09": 4.42,
  "2025-04-10": 4.37,
  "2025-04-11": 4.33,
  "2025-04-14": 4.33,
  "2025-04-15": 4.36,
  "2025-04-16": 4.31,
  "2025-04-17": 4.32,
  "2025-04-21": 4.32,
  "2025-04-22": 4.3,
  "2025-04-23": 4.28,
  "2025-04-24": 4.29,
  "2025-04-25": 4.33,
  "2025-04-28": 4.36,
  "2025-04-29": 4.36,
  "2025-04-30": 4.41,
  "2025-05-01": 4.39,
  "2025-05-02": 4.36,
  "2025-05-05": 4.33,
  "2025-05-06": 4.32,
  "2025-05-07": 4.3,
  "2025-05-08": 4.29,
  "2025-05-09": 4.28,
  "2025-05-12": 4.28,
  "2025-05-13": 4.3,
  "2025-05-14": 4.29,
  "2025-05-15": 4.31,
  "2025-05-16": 4.3,
  "2025-05-19": 4.29,
  "2025-05-20": 4.27,
  "2025-05-21": 4.26,
  "2025-05-22": 4.26,
  "2025-05-23": 4.26,
  "2025-05-27": 4.31,
  "2025-05-28": 4.33,
  "2025-05-29": 4.33,
  "2025-05-30": 4.35,
  "2025-06-02": 4.35,
  "2025-06-03": 4.32,
  "2025-06-04": 4.28,
  "2025-06-05": 4.29,
  "2025-06-06": 4.29,
  "2025-06-09": 4.29,
  "2025-06-10": 4.28,
  "2025-06-11": 4.28,
  "2025-06-12": 4.28,
  "2025-06-13": 4.28,
  "2025-06-16": 4.32,
  "2025-06-17": 4.31,
  "2025-06-18": 4.28,
  "2025-06-20": 4.29,
  "2025-06-23": 4.29,
  "2025-06-24": 4.3,
  "2025-06-25": 4.36,
  "2025-06-26": 4.4,
  "2025-06-27": 4.39,
  "2025-06-30": 4.45,
  "2025-07-01": 4.44,
  "2025-07-02": 4.4,
  "2025-07-03": 4.35,
  "2025-07-07": 4.33,
  "2025-07-08": 4.34,
  "2025-07-09": 4.32,
  "2025-07-10": 4.31,
  "2025-07-11": 4.31,
  "2025-07-14": 4.33,
  "2025-07-15": 4.37,
  "2025-07-16": 4.34,
  "2025-07-17": 4.34,
  "2025-07-18": 4.3,
  "2025-07-21": 4.28,
  "2025-07-22": 4.28,
  "2025-07-23": 4.28,
  "2025-07-24": 4.3,
  "2025-07-25": 4.36,
  "2025-07-28": 4.36,
  "2025-07-29": 4.36,
  "2025-07-30": 4.32,
  "2025-07-31": 4.39,
  "2025-08-01": 4.34,
  "2025-08-04": 4.33,
  "2025-08-05": 4.34,
  "2025-08-06": 4.34,
  "2025-08-07": 4.35,
  "2025-08-08": 4.35,
  "2025-08-11": 4.34,
  "2025-08-12": 4.36,
  "2025-08-13": 4.33,
  "2025-08-14": 4.34,
  "2025-08-15": 4.36,
  "2025-08-18": 4.34,
  "2025-08-19": 4.33,
  "2025-08-20": 4.31,
  "2025-08-21": 4.32,
  "2025-08-22": 4.36,
  "2025-08-25": 4.37,
  "2025-08-26": 4.38,
  "2025-08-27": 4.36,
  "2025-08-28": 4.34,
  "2025-08-29": 4.34,
  "2025-09-02": 4.39,
  "2025-09-03": 4.39,
  "2025-09-04": 4.41,
  "2025-09-05": 4.42,
  "2025-09-08": 4.4,
  "2025-09-09": 4.4,
  "2025-09-10": 4.39,
  "2025-09-11": 4.41,
  "2025-09-12": 4.42,
  "2025-09-15": 4.51,
  "2025-09-16": 4.39,
  "2025-09-17": 4.38,
  "2025-09-18": 4.14,
  "2025-09-19": 4.14,
  "2025-09-22": 4.14,
  "2025-09-23": 4.12,
  "2025-09-24": 4.13,
  "2025-09-25": 4.18,
  "2025-09-26": 4.16,
  "2025-09-29": 4.13,
  "2025-09-30": 4.24,
  "2025-10-01": 4.2,
  "2025-10-02": 4.2,
  "2025-10-03": 4.18,
  "2025-10-06": 4.15,
  "2025-10-07": 4.14,
  "2025-10-08": 4.12,
  "2025-10-09": 4.13,
  "2025-10-10": 4.15,
  "2025-10-14": 4.19,
  "2025-10-15": 4.29,
  "2025-10-16": 4.3,
  "2025-10-17": 4.18,
  "2025-10-20": 4.16,
  "2025-10-21": 4.23,
  "2025-10-22": 4.21,
  "2025-10-23": 4.24,
  "2025-10-24": 4.24,
  "2025-10-27": 4.27,
  "2025-10-28": 4.31,
  "2025-10-29": 4.27,
  "2025-10-30": 4.04,
  "2025-10-31": 4.22,
  "2025-11-03": 4.13,
  "2025-11-04": 4.0,
  "2025-11-05": 3.91,
  "2025-11-06": 3.92,
  "2025-11-07": 3.93,
  "2025-11-10": 3.95,
  "2025-11-12": 3.98,
  "2025-11-13": 4.0,
  "2025-11-14": 3.95,
  "2025-11-17": 4.0,
  "2025-11-18": 3.94,
  "2025-11-19": 3.91,
  "2025-11-20": 3.91,
  "2025-11-21": 3.93,
  "2025-11-24": 3.96,
  "2025-11-25": 4.01,
  "2025-11-26": 4.05,
  "2025-11-28": 4.12,
  "2025-12-01": 4.12,
  "2025-12-02": 4.01,
  "2025-12-03": 3.95,
  "2025-12-04": 3.92,
  "2025-12-05": 3.93,
  "2025-12-08": 3.95,
  "2025-12-09": 3.93,
  "2025-12-10": 3.9,
  "2025-12-11": 3.66,
  "2025-12-12": 3.67,
  "2025-12-15": 3.75,
  "2025-12-16": 3.69,
  "2025-12-17": 3.69,
  "2025-12-18": 3.66,
  "2025-12-19": 3.66,
  "2025-12-22": 3.68,
  "2025-12-23": 3.66,
  "2025-12-24": 3.66,
  "2025-12-26": 3.76,
  "2025-12-29": 3.77,
  "2025-12-30": 3.71,
  "2025-12-31": 3.87,
  "2026-01-02": 3.75,
  "2026-01-05": 3.7,
  "2026-01-06": 3.66,
  "2026-01-07": 3.65,
  "2026-01-08": 3.64,
  "2026-01-09": 3.64,
  "2026-01-12": 3.64,
  "2026-01-13": 3.65,
  "2026-01-14": 3.64,
  "2026-01-15": 3.66,
  "2026-01-16": 3.65,
  "2026-01-20": 3.64,
  "2026-01-21": 3.63,
  "2026-01-22": 3.64,
  "2026-01-23": 3.65,
  "2026-01-26": 3.66,
  "2026-01-27": 3.66,
  "2026-01-28": 3.64,
  "2026-01-29": 3.65,
  "2026-01-30": 3.68,
  "2026-02-02": 3.69,
  "2026-02-03": 3.69,
  "2026-02-04": 3.65,
  "2026-02-05": 3.65,
  "2026-02-06": 3.64,
  "2026-02-09": 3.63,
  "2026-02-10": 3.65,
  "2026-02-11": 3.65,
  "2026-02-12": 3.65,
  "2026-02-13": 3.66,
  "2026-02-17": 3.71,
  "2026-02-18": 3.73,
  "2026-02-19": 3.67,
  "2026-02-20": 3.66,
  "2026-02-23": 3.66,
  "2026-02-24": 3.67,
  "2026-02-25": 3.67,
  "2026-02-26": 3.67,
  "2026-02-27": 3.68,
  "2026-03-02": 3.71,
  "2026-03-03": 3.7,
  "2026-03-04": 3.67,
  "2026-03-05": 3.66,
  "2026-03-06": 3.65,
  "2026-03-09": 3.65,
  "2026-03-10": 3.64,
  "2026-03-11": 3.64,
  "2026-03-12": 3.65,
  "2026-03-13": 3.65,
  "2026-03-16": 3.7,
  "2026-03-17": 3.65,
  "2026-03-18": 3.62,
  "2026-03-19": 3.62,
  "2026-03-20": 3.62,
  "2026-03-23": 3.62,
  "2026-03-24": 3.63,
  "2026-03-25": 3.64,
  "2026-03-26": 3.65,
  "2026-03-27": 3.63,
  "2026-03-30": 3.63,
  "2026-03-31": 3.68,
  "2026-04-01": 3.65,
  "2026-04-02": 3.66,
  "2026-04-06": 3.65,
  "2026-04-07": 3.62,
  "2026-04-08": 3.59,
  "2026-04-09": 3.57,
  "2026-04-10": 3.61,
  "2026-04-13": 3.63,
  "2026-04-14": 3.66,
  "2026-04-15": 3.72,
  "2026-04-16": 3.67,
  "2026-04-17": 3.65,
  "2026-04-20": 3.63,
  "2026-04-21": 3.63,
  "2026-04-22": 3.64,
  "2026-04-23": 3.65,
  "2026-04-24": 3.66,
  "2026-04-27": 3.66,
  "2026-04-28": 3.64,
  "2026-04-29": 3.63,
  "2026-04-30": 3.66,
  "2026-05-01": 3.64,
  "2026-05-04": 3.63,
  "2026-05-05": 3.62,
  "2026-05-06": 3.61,
  "2026-05-07": 3.6,
  "2026-05-08": 3.6,
  "2026-05-11": 3.6,
  "2026-05-12": 3.6,
  "2026-05-13": 3.59,
  "2026-05-14": 3.56,
  "2026-05-15": 3.55,
  "2026-05-18": 3.53,
  "2026-05-19": 3.51,
  "2026-05-20": 3.5,
  "2026-05-21": 3.51,
  "2026-05-22": 3.55,
  "2026-05-26": 3.63,
  "2026-05-27": 3.63,
  "2026-05-28": 3.62,
  "2026-05-29": 3.63,
  "2026-06-01": 3.65,
  "2026-06-02": 3.63,
  "2026-06-03": 3.61,
  "2026-06-04": 3.62,
  "2026-06-05": 3.63,
  "2026-06-08": 3.63,
  "2026-06-09": 3.6,
  "2026-06-10": 3.59,
  "2026-06-11": 3.6,
  "2026-06-12": 3.65,
  "2026-06-15": 3.69,
  "2026-06-16": 3.63,
  "2026-06-17": 3.63,
  "2026-06-18": 3.62,
  "2026-06-22": 3.61,
  "2026-06-23": 3.62,
  "2026-06-24": 3.62,
  "2026-06-25": 3.64,
  "2026-06-26": 3.62,
  "2026-06-29": 3.62,
  "2026-06-30": 3.68,
  "2026-07-01": 3.66,
  "2026-07-02": 3.64,
  "2026-07-06": 3.63,
  "2026-07-07": 3.62,
  "2026-07-08": 3.58,
  "2026-07-09": 3.53,
  "2026-07-10": 3.55,
  "2026-07-13": 3.6,
  "2026-07-14": 3.63,
  "2026-07-15": 3.64,
  "2026-07-16": 3.62,
  "2026-07-17": 3.59,
  "2026-07-20": 3.57,
};
